import { orange } from "@mui/material/colors";
import React, { Component } from "react";
import { IPropsIcone } from "../../modelo/Icone";

interface IPropsIconePje extends IPropsIcone {
  width?: string;
  height?: string;
}

class IconePje extends Component<IPropsIconePje> {
  constructor(props) {
    super(props);
  }

  render() {
    const width = this.props.width || "32px";
    const height = this.props.height || "32px";
    return (
      // <Avatar src="../img/logo-pje.png" variant="square" style={{width: '32px', height:'32px'}} imgProps={{ style: { objectFit: 'scale-down' } }} />
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width={width} height={height} viewBox="0 0 91.000000 64.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
          className="icone-sistema-origem-base" fill="#000000" stroke="none">
          <path d="M107 513 c-4 -3 -7 -91 -7 -195 0 -180 1 -188 19 -188 30 0 51 39 51
            92 l0 48 63 0 c34 0 73 6 86 13 84 43 89 181 9 223 -28 14 -208 21 -221 7z
            m197 -75 c22 -31 20 -64 -4 -88 -15 -15 -33 -20 -75 -20 l-55 0 0 65 0 65 59
            0 c51 0 62 -3 75 -22z"/>
          <path d="M447 502 c-14 -15 -17 -41 -17 -135 0 -135 -8 -164 -47 -172 -42 -9
            -58 -20 -58 -41 0 -15 9 -20 39 -22 21 -2 52 2 68 9 51 21 62 57 66 227 4 145
            3 152 -15 152 -11 0 -27 -8 -36 -18z"/>
          <path d="M613 461 c-70 -33 -95 -120 -53 -188 36 -59 125 -82 191 -47 37 19
            36 51 -1 46 -14 -2 -44 -6 -67 -9 -33 -4 -45 -1 -63 17 -37 37 -22 45 88 45
            100 0 102 1 102 23 0 99 -101 158 -197 113z m117 -51 c39 -39 27 -50 -55 -50
            -82 0 -94 11 -53 50 28 26 82 26 108 0z"
            style={{ fill: orange[900] }}
          />
        </g>
      </svg>
    );
  }
}

export default IconePje;
